import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import addOutreachReducer from '../reducers/addOutreachReducer';

const configureStore = (railsProps) => (
  createStore(addOutreachReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
